import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Fowler',
  description: 'Licensed electrician serving Fowler, CA. C-10 certified electrical contractor for residential and commercial electrical work in Fowler and Fresno County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Fowler',
    addressRegion: 'CA',
    postalCode: '93625',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.6302', longitude: '-119.6746' },
  url: 'https://electriciansolutionsfresno.com/areas/fowler',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Fowler', '@id': 'https://en.wikipedia.org/wiki/Fowler,_California' },
};

const faqs = [
  {
    q: 'Do you provide electrical services in Fowler, CA?',
    a: 'Yes! Electrician Solutions Fresno serves Fowler, CA and surrounding Fresno County with full C-10 licensed electrical services. Fowler is just 12 miles south of Fresno, making us ideally positioned to serve this close-knit Central Valley community.',
  },
  {
    q: 'What electrical services do you offer in Fowler?',
    a: 'We provide complete electrical services in Fowler including panel upgrades, home rewiring, EV charger installations, new circuit additions, kitchen and bathroom electrical, smart home systems, and 24/7 emergency electrical repairs for Fowler homes and businesses.',
  },
  {
    q: 'How quickly can an electrician reach Fowler?',
    a: 'Fowler is only 12 miles south of Fresno via Highway 99. Our emergency electricians can typically reach Fowler in 20–35 minutes. We offer fast, reliable service for all Fowler electrical emergencies.',
  },
  {
    q: 'Do you work on older Fowler homes with outdated wiring?',
    a: 'Absolutely. Many Fowler homes were built in the mid-20th century with outdated aluminum wiring, Federal Pacific panels, or insufficient 60A service. We specialize in modernizing these older electrical systems to current California code.',
  },
  {
    q: 'Do you serve the agricultural area surrounding Fowler?',
    a: 'Yes. The Fowler area is surrounded by fruit orchards and vineyards. We serve agricultural properties throughout the Fowler area including pump stations, irrigation wiring, packing shed electrical, and solar installations for local farms.',
  },
  {
    q: 'Are your electricians licensed for work in Fowler?',
    a: 'Yes. All our electricians hold valid California C-10 electrical contractor licenses and are fully insured and bonded to work in Fowler, Fresno County. We handle all required City of Fowler permits as part of every project.',
  },
];

const FowlerPage = () => (
  <AreaTemplate
    area="Fowler"
    areaSlug="fowler"
    state="CA"
    county="Fresno County"
    population="7,000+"
    description="Electrician Solutions Fresno serves Fowler, CA — the Raisin Center of the World — and surrounding Fresno County with professional C-10 licensed electrical services. Just 12 miles south of Fresno, Fowler is a warm, close-knit agricultural community with a growing residential base. Our certified Fowler electricians are your neighbors, delivering personalized electrical services to homes, farms, and businesses throughout the area."
    neighborhoods={['Downtown Fowler', 'North Fowler', 'East Fowler', 'Merced Ave Area', 'Highway 99 Corridor', 'South Fowler', 'Fowler Ranch Area', 'Malaga vicinity']}
    nearbyAreas={[
      { name: 'Fresno', slug: 'fresno' },
      { name: 'Selma', slug: 'selma' },
      { name: 'Clovis', slug: 'clovis' },
      { name: 'Sanger', slug: 'sanger' },
      { name: 'Reedley', slug: 'reedley' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/69041fe4e6f0a219d84a944ea5145b96.jpg"
    heroImageAlt="Licensed Electrician in Fowler CA"
    teamImage="https://readdy.ai/api/search-image?query=Electrician%20team%20in%20professional%20uniforms%20standing%20in%20front%20of%20Fowler%20California%20raisin%20grape%20vineyards%20and%20fruit%20orchards%20Central%20Valley%20landscape%20warm%20golden%20California%20light%20showing%20local%20agricultural%20community%20expertise&width=800&height=600&seq=fowler_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Fowler CA"
    schema={schema}
  />
);

export default FowlerPage;
